import React from 'react';

/**
 * Noor brand mark: an ivory serif "N" inside a navy squircle badge with a
 * thin gold border.
 *
 * Updated (2026-09-21): the badge shape moved from a full circle to a
 * rounded square ("squircle"). A perfect circle with a gold ring reads too
 * close to an official government seal for a private, non-government
 * service like Noor — the squircle keeps the same premium navy/gold/serif
 * identity but reads as a modern app-style mark instead. The "N" itself
 * also dropped the gold outline-stroke treatment in favor of a single clean
 * ivory fill, which stays legible at very small sizes (favicons, chat
 * avatars) where the old double-stroke look blurred together.
 *
 * - <NoorBadge/>  : the squircle badge mark only (use in header / favicon / small spots)
 * - <NoorLockup/> : badge + "NOOR PASSPORT SERVICES" wordmark + gold tagline
 *                   (use on dark/navy areas: footer, social, printed packet)
 */

const NAVY = '#16243F';
const GOLD = '#B08A2E';
const IVORY = '#F4ECD6';
export function NoorBadge({
  size = 36,
  className = '',
  title = 'Noor Passport Services'
}: {
  size?: number;
  className?: string;
  title?: string;
}) {
  return <svg width={size} height={size} viewBox="0 0 100 100" role="img" aria-label={title} className={className} data-id="element-281" data-mp="204ytv0l9vtiw">
      {/* squircle badge: rounded-square navy fill with a thin gold border */}
      <rect x="5" y="5" width="90" height="90" rx="22" ry="22" fill={NAVY} stroke={GOLD} strokeWidth="3" data-id="element-282" data-mp="1q715md3exwqa" />
      {/* serif N: single clean ivory fill, no outline — stays crisp at small sizes */}
      <text x="50" y="52" textAnchor="middle" dominantBaseline="central" fontFamily="Georgia, 'Times New Roman', serif" fontSize="62" fontWeight="700" fill={IVORY} data-id="element-283" data-mp="1c79mjxy1hq5f">
        N
      </text>
    </svg>;
}
export function NoorLockup({
  className = '',
  badgeSize = 96
}: {
  className?: string;
  badgeSize?: number;
}) {
  return <div className={`flex flex-col items-center text-center ${className}`} data-id="element-284" data-mp="19mbpqn77qg2a">
      <NoorBadge size={badgeSize} data-id="element-285" data-mp="19oep3xu99ljo" />
      <p className="font-heading font-bold tracking-wide mt-4" style={{
      color: IVORY,
      fontSize: 'clamp(20px, 4vw, 30px)',
      letterSpacing: '0.06em'
    }} data-id="element-286" data-mp="uygtiwtzxtkg">
        NOOR PASSPORT SERVICES
      </p>
      <p className="italic mt-1" style={{
      color: GOLD,
      fontFamily: "Georgia, 'Times New Roman', serif",
      fontSize: 'clamp(14px, 2.4vw, 18px)'
    }} data-id="element-287" data-mp="1nk9z1e6ofmax">
        We prepare. You submit. Simple.
      </p>
    </div>;
}